import * as mapbox from 'mapbox-gl';
import React from 'react';
import { useMapRadius } from '../../hooks/useMapRadius';
import { Around as TAround } from '../../types/Around';

type Props = {
    map: mapbox.Map;
    around: TAround;
}

export const Around: React.FC<Props> = ({ map, around }) => {
    useMapRadius(map, around.lat, around.lng, around.radius);

    return null;
}